import { IOrganizationResponse } from "@/shared/types"

export const getDefaultUserOrganization = (
  organizations: IOrganizationResponse[],
  defaultOrganizationId: string,
): IOrganizationResponse => organizations.find((i) => i.id === defaultOrganizationId) || organizations[0]
